export default function onImageBlob(imageBlob, file) {
    if (!imageBlob) return;
    var URLObj = window.URL || window.webkitURL;
    this.img_src = URLObj.createObjectURL(imageBlob);
    this.filename = file || "paste-" + new Date().toJSON().replace(/\D/g, "") + ".jpg";
    this.dialog = true;
}
